module.exports = __webpack_public_path__ + "fonts/opensans-lightitalic-webfont.8d797d0e.eot";